import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the sales reps api
 */
export class SalesRepService extends BaseService {

	constructor() {	
		super();
	}
	
	async getSaleReps(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/sales-reps' + params);		
		return data;		
	}
	
	async getSaleRep(salesRepId) {
		var data = await this.makeGETRequest('/api/resource/sales-reps/' + salesRepId);		
		return data;		
	}
	
	async saveSaleRep(saveRep, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/sales-reps/' + saveRep.salesRepId, saveRep);
		} else {
			saved = await this.makePOSTRequest('/api/resource/sales-reps', saveRep);
		}
		return saved;		
	}	
	
	async deleteSaleRep(salesRepId) {
		var data = await this.makeDELETERequest('/api/resource/sales-reps/' + salesRepId);		
		return data;		
	}	
	
}